import {
  put, takeLatest, call, all, fork,
} from 'redux-saga/effects';
import { isFunction } from 'lodash';
import {
  FETCH_USER_BY_ADDRESS,
} from '../actions/tools/action_types';
import actions from '../actions/tools';
import rf from '../../requests/RequestFactory';
import consts from '../../consts';
// saga effect

function* fetchUserByAddress(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('ToolsRequest').fetchUserByAddress(params), action.params);
    if (isFunction(action.callback)) {
      yield action.callback(data);
    }

    yield put(actions.onFetchUserByAddressSucceed(data));
  } catch (err) {
    yield put(actions.onFetchUserByAddressFailed(err));
  }
}

function* watchTools() {
  yield takeLatest(FETCH_USER_BY_ADDRESS, fetchUserByAddress);
}

export default function* rootSaga() {
  yield all([fork(watchTools)]);
}
